import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  COLUMN_DEFAULTS,
  TColumnProps,
  COLUMN_RESPONSIVE_SPANS_CLASS_MAP,
} from "@/ui/components/layout/Column";

export const Column: FC<TColumnProps> = (
  {
    tag: Tag = COLUMN_DEFAULTS.tag,
    spans = COLUMN_DEFAULTS.spans,
    className,
    children,
    ...props
  },
) => {

  return (
    <Tag
      {...props}
      data-component="Column"
      className={cn(
        "flex box-border",
        makeBreakpointClassName(spans, COLUMN_RESPONSIVE_SPANS_CLASS_MAP, COLUMN_DEFAULTS.spans),
        className,
      )}
    >
      { children }
    </Tag>
  );
};

Column.displayName = "Column";
